export const SET_SEARCH_NAVER_PLACE_DATA = 'native/SET_SEARCH_NAVER_PLACE_DATA';
export const USE_SEARCH_NAVER_PLACE_DATA = 'native/USE_SEARCH_NAVER_PLACE_DATA';
export const SET_NAVER_PLACE_API_DATA = 'native/SET_NAVER_PLACE_API_DATA';
export const USE_NAVER_PLACE_API_DATA = 'native/USE_NAVER_PLACE_API_DATA';
export const SET_NAVER_TRAFFIC_CONDITION_DATA = 'native/SET_NAVER_TRAFFIC_CONDITION_DATA';
export const USE_NAVER_TRAFFIC_CONDITION_DATA = 'native/USE_NAVER_TRAFFIC_CONDITION_DATA';
export const SET_CURRENT_LOCATION = 'native/SET_CURRENT_LOCATION';
export const USE_CURRENT_LOCATION = 'native/USE_CURRENT_LOCATION';

const initialState = {
    usedSearchNaverPlaceData: true,
    searchNaverPlaceTarget: null,
    searchNaverPlaceData: {},
    usedNaverPlaceApiData: true,
    naverPlaceApiTarget: null,
    naverPlaceApiData: {},
    usedNaverTrafficConditionData: true,
    naverTrafficConditionTarget: null,
    naverTrafficConditionData: {},
    usedCurrentLocation: true,
    currentLocation: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_SEARCH_NAVER_PLACE_DATA:
            return {
                ...state,
                usedSearchNaverPlaceData: false,
                searchNaverPlaceData: action.data,
                searchNaverPlaceTarget: action.target
            };
        case USE_SEARCH_NAVER_PLACE_DATA:
            return {
                ...state,
                usedSearchNaverPlaceData: true
            };
        case SET_NAVER_PLACE_API_DATA:
            return {
                ...state,
                usedNaverPlaceApiData: false,
                naverPlaceApiData: action.data,
                naverPlaceApiTarget: action.target
            };
        case USE_NAVER_PLACE_API_DATA:
            return {
                ...state,
                usedNaverPlaceApiData: true
            };
        case SET_NAVER_TRAFFIC_CONDITION_DATA:
            return {
                ...state,
                usedNaverTrafficConditionData: false,
                naverTrafficConditionData: action.data,
                naverTrafficConditionTarget: action.target
            };
        case USE_NAVER_TRAFFIC_CONDITION_DATA:
            return {
                ...state,
                usedNaverTrafficConditionData: true
            };
        case SET_CURRENT_LOCATION:
            return {
                ...state,
                usedCurrentLocation: false,
                currentLocation: action.data
            };
        case USE_CURRENT_LOCATION:
            return {
                ...state,
                usedCurrentLocation: true
            };
        default:
            return state
    }
}

export const setSearchNaverPlaceData = (data, target) => {
    return dispatch => {
        dispatch({
            type: SET_SEARCH_NAVER_PLACE_DATA,
            data: data,
            target: target
        });
    }
};

export const useSearchNaverPlaceData = () => {
    return dispatch => {
        dispatch({
            type: USE_SEARCH_NAVER_PLACE_DATA
        });
    }
};

export const setNaverPlaceApiData = (data, target) => {
    return dispatch => {
        dispatch({
            type: SET_NAVER_PLACE_API_DATA,
            data: data,
            target: target
        });
    }
};

export const useNaverPlaceApiData = () => {
    return dispatch => {
        dispatch({
            type: USE_NAVER_PLACE_API_DATA
        });
    }
};

export const setNaverTrafficConditionData = (data, target) => {
    return dispatch => {
        dispatch({
            type: SET_NAVER_TRAFFIC_CONDITION_DATA,
            data: data,
            target: target
        });
    }
};

export const useNaverTrafficConditionData = () => {
    return dispatch => {
        dispatch({
            type: USE_NAVER_TRAFFIC_CONDITION_DATA
        });
    }
};

export const setCurrentLocation = (data) => {
    return dispatch => {
        dispatch({
            type: SET_CURRENT_LOCATION,
            data: data
        });
    }
};

export const useCurrentLocation = () => {
    return dispatch => {
        dispatch({
            type: USE_CURRENT_LOCATION
        });
    }
};